import './mavris/style';
import FormStructure from './mavris/form_structure';

export default FormStructure;